<template>
  <div
    class="liquor-multi-media"
    :style="`width: ${width}px; height: ${height}px;`"
    @mouseover="playing = false"
    @mouseleave="playing = true; play(currentIndex)"
  >
    <div
      class="multimedia"
      :style="`width: ${this.width * list.length}px; height: ${height}px; transform: translateX(${left}px);`"
    >
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        :style="`width: ${width}px; height: ${height}px;`"
      >
        <img
          :src="util.getImageUrl(item.src, `${width}x${height}`)"
          v-if="item.type === 'IMAGE'"
          @load="e => onCanPlay(index, e)"
        />
        <video
          v-if="item.type === 'VIDEO'"
          controls
          muted
          preload
          @canplay="e => onCanPlay(index, e)"
          @ended="e => onEnded(index, e)"
        >
          <source :src="util.getImageUrl(item.src)" type="video/mp4" />
        </video>
        <audio
          :src="util.getImageUrl(item.src)"
          v-if="item.type === 'AUDIO'"
          @canplay="e => onCanPlay(index, e)"
          @ended="e => onEnded(index, e)"
          preload
          controls
          muted
        />
      </div>
    </div>
    <div class="controls" v-if="controls && list.length > 1">
      <div class="prev" @click.stop="onPrev">
        <img src="/liquor/左（翻页）.png" />
      </div>
      <div class="next" @click.stop="onNext">
        <img src="/liquor/右（翻页）.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiMedia",
  props: {
    list: {
      type: Array,
      required: true
    },
    width: {
      type: Number,
      default: 538
    },
    height: {
      type: Number,
      default: 538
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // left: 0,
      currentIndex: 0,
      elementArray: new Array(this.list.length),
      playing: false
    };
  },
  computed: {
    left: function() {
      return -this.width * this.currentIndex;
    }
  },
  watch: {
    currentIndex: function(val) {
      this.play(val);
    }
  },
  created() {
    if (this.autoplay) {
      this.playing = true;
    }
  },
  methods: {
    onPlaying(index, e) {
      // console.log(index, e);
    },
    onPlay(index, e) {
      // console.log(index, e);
    },
    onEnded(index, e) {
      if (this.playing) {
        if (!this.onNext()) {
          this.seek(0);
        }
      }
    },
    play(index) {
      if (this.playing) {
        if (this.list[index].type !== "IMAGE") {
          this.elementArray[index].play();
        } else {
          setTimeout(this.onEnded, 3000);
        }
      }
    },
    onCanPlay(index, e) {
      this.elementArray[index] = e.target;
      if (index === 0 && this.autoplay) {
        this.play(0);
      }
    },
    seek(index) {
      if (index >= 0 && index < this.list.length) {
        this.currentIndex = index;
        return true;
      }
      return false;
    },
    onPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        return true;
      }
      return false;
    },
    onNext() {
      if (this.currentIndex < this.list.length - 1) {
        this.currentIndex += 1;
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-multi-media {
  background: rgba(250, 250, 250, 1);
  overflow: hidden;
  position: relative;
  .multimedia {
    transition: all 0.6s ease-out;
    .item {
      width: 100%;
      height: 100%;
      display: inline-block;
      background: rgba(250, 250, 250, 1);
      img,
      video,
      audio {
        background: rgba(250, 250, 250, 1);
        width: 100%;
        height: 100%;
      }
      video {
        background: black;
        width: 100%;
        height: 100%;
      }
    }
  }
  .controls {
    // transition: all 0.6s ease-out;
    width: 100%;
    height: 8%;
    position: absolute;
    left: 0;
    top: 46%;
    display: none;
    .prev,
    .next {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 8%;
      height: 100%;
      background: rgba(228, 200, 150, 1);
      opacity: 0.6;

      cursor: pointer;
      img {
        width: 11px;
        height: 11px;
      }
    }

    .prev:hover,
    .next:hover {
      opacity: 1;
    }

    .prev {
      float: left;
    }

    .next {
      float: right;
    }
  }
}
.liquor-multi-media:hover {
  .controls {
    display: block;
  }
}
</style>